// WORLD CLICKS on the field's creatures — the crow, a citizen — routed BEFORE click-to-move (a capture listener on the canvas), and
// only when nothing else owns the click: no tool armed (1 = shoot, 2 = citizen care), no placement, not on an adventure.
// Targets are tried in order; the first hit that is handled stops the click there.
import * as THREE from 'three'
import * as toolMode from '../game/toolMode.js'
import { isPlacementActive } from './placement.js'
import * as advManager from '../game/adventureManager.js'

export function mountFieldClicks({ canvas, camera, targets }) { // targets: [{ pick: () => Object3D[], hit: (root, intersection) => boolean }]
  const ray = new THREE.Raycaster(), ndc = new THREE.Vector2()
  const rootOf = (obj, roots) => { let o = obj; while (o && !roots.has(o)) o = o.parent; return o }
  canvas.addEventListener('click', (e) => {
    if (toolMode.getToolMode() !== toolMode.ToolModes.OFF || isPlacementActive() || advManager.isAdventuring()) return
    const r = canvas.getBoundingClientRect()
    ndc.x = ((e.clientX - r.left) / r.width) * 2 - 1
    ndc.y = -((e.clientY - r.top) / r.height) * 2 + 1
    ray.setFromCamera(ndc, camera)
    for (const t of targets) {
      const objs = t.pick().filter((o) => o && o.visible)
      if (!objs.length) continue
      const hits = ray.intersectObjects(objs, true)
      if (!hits.length) continue
      const root = rootOf(hits[0].object, new Set(objs))
      if (root && t.hit(root, hits[0]) !== false) { e.stopImmediatePropagation(); e.preventDefault(); return }
    }
  }, true)
}
